import {
  IonContent,
  IonHeader,
  IonToolbar,
  IonIcon,
  IonText,
  IonItem,
  IonInput,
  IonButton,
  IonBadge,
  useIonAlert,
  IonRefresher,
  IonRefresherContent,
  RefresherEventDetail,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonImg,
  IonCardHeader,
  IonCardTitle,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonSkeletonText,
  IonCardSubtitle,
  IonTitle,
  IonLabel,
  IonPage,
  IonModal,
  IonList,
  IonFab,
  IonFabButton,
  IonItemGroup,
  IonItemDivider,
} from "@ionic/react";
import {
  arrowBackOutline,
  cashOutline,
  chevronDownCircleOutline,
  cubeOutline,
  fileTrayStackedOutline,
  medalOutline,
  ribbonOutline,
  searchOutline,
  timerOutline,
  shieldCheckmarkOutline,
  discOutline,
  searchCircle,
} from "ionicons/icons";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { RestApi } from "../../services/Api";
import {
  Rupiah,
  getNameDate,
  paramsUrl,
  useConstructor,
} from "../../services/Library";
import { loadList } from "../../models/Data";
import type { Contract as ContractProps } from "../../models/Modal";
import "./Contract.scss";
import { OverlayEventDetail } from "@ionic/core";

const Contract: React.FC<ContractProps> = ({
  onDismissDetail,
  idCustomer,
}) => {
  const [alert] = useIonAlert();
  const [isInfiniteDisabled, setInfiniteDisabled] = useState(false);
  const [contractIsActive, setContractIsActive] = useState<number>(1);
  const [showModalFilter, setShowModalFilter] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [listContract, setListContract] = useState<any>([]);
  const [dataContract, setDataContract] = useState<any>(null);
  const [query, setQuery] = useState<any>(null);
  const { t } = useTranslation(["general"]);

  const massageAlert = async (status: string, body: string) => {
    alert({
      header: t(status),
      message: body,
      cssClass: `header-alert-${status}`,
      buttons: [
        {
          cssClass: "alert-button-confirm",
          text: t("yes"),
        },
      ],
    });
  };

  const getContract = async (page: string, next: boolean) => {
    await RestApi(page, "get", {}, "application/json")
      .then(async (res: any) => {
        if (res.data.status) {
          setDataContract(res.data.data);
          if (next) {
            setListContract((prevState: any) => [
              ...prevState,
              ...res.data.data.data,
            ]);
          } else {
            setListContract(res.data.data.data);
          }
        } else {
          onDismissDetail();
          massageAlert("error", res.data.message);
        }
      })
      .catch((err: any) => {
        onDismissDetail();
        massageAlert("error", err.message);
      });
  };

  const doRefresh = (event: CustomEvent<RefresherEventDetail>) => {
    getContract(`contract/${idCustomer}?keyword=${searchText}`, false);
    event.detail.complete();
  };

  const onChangeSearch = (e: any) => {
    e.preventDefault();
    setSearchText(e.detail.value!);
    getContract(`contract/${idCustomer}?keyword=${e.detail.value!}`, false);
  };

  const loadData = (ev: any) => {
    if (dataContract.current_page === dataContract.last_page) {
      setInfiniteDisabled(true);
      return;
    }
    getContract(
      `contract/${idCustomer}?page=${
        dataContract.current_page + 1
      }&keyword=${searchText}&${paramsUrl(query)}`,
      true
    );
    ev.target.complete();
  };

  const handleModalCloseFilter = async (filter: any) => {
    setShowModalFilter(false);
    if (filter) {
      setQuery(filter);
      getContract(
        `contract/${idCustomer}?contractIsActive=${contractIsActive}&keyword=${searchText}&${paramsUrl(filter)}`,
        false
      );
    }
  };

  useConstructor(async () => {
    getContract(
      `contract/${idCustomer}?contractIsActive=${contractIsActive}&${paramsUrl(
        query
      )}`,
      false
    );
  });

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButton
            color="light"
            slot="start"
            fill="clear"
            onClick={onDismissDetail}
          >
            <IonIcon color="light" slot="start" src={arrowBackOutline} />
          </IonButton>
          <div className="search">
            <IonItem lines="full" className="item" slot="start">
              <IonIcon src={searchOutline} slot="start" />
              <IonInput
                placeholder={t("search") + " " + t("contract")}
                className="input"
                clearInput={true}
                value={searchText}
                onIonChange={(e) => onChangeSearch(e)}
              ></IonInput>
            </IonItem>
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent
            pullingIcon={chevronDownCircleOutline}
            pullingText={`${t("loading")}`}
            refreshingSpinner="circles"
            refreshingText={`${t("loading")}`}
          ></IonRefresherContent>
        </IonRefresher>
        <IonRow>
          <IonCol size="12">
            <IonButton
              className="ion-no-padding ion-no-margin"
              expand="block"
              fill="outline"
              color={contractIsActive ? "danger" : "medium"}
              onClick={() => {
                setSearchText("");
                setContractIsActive(1);
                getContract(
                  `contract/${idCustomer}?contractIsActive=1?keyword=${searchText}&${paramsUrl(
                    query
                  )}`,
                  false
                );
              }}
              size="small"
            >
              {t("active")}
              <IonIcon size="small" src={shieldCheckmarkOutline}></IonIcon>
            </IonButton>
          </IonCol>
        </IonRow>
        {listContract.length ? (
          <IonGrid>
            <IonRow className="Contract-card">
              {listContract.map((value: any, key: any) => (
                <IonCol size="12" key={key}>
                  <IonCard>
                    <IonItem className="ion-no-padding ion-no-margin">
                      <IonIcon
                        size="small"
                        color="dark"
                        src={ribbonOutline}
                      ></IonIcon>
                      <IonText>
                        <span>{value.contract_type_name}</span>
                        <br />
                        <span>
                          <strong>{value.contract_name}</strong>
                        </span>
                        <br />
                        <span>
                          <IonIcon
                            size="small"
                            color="dark"
                            src={timerOutline}
                          ></IonIcon>
                          {" " +
                            getNameDate(value.contract_start_date) +
                            " ~ " +
                            getNameDate(value.contract_end_date)}
                        </span>
                      </IonText>
                    </IonItem>
                    <IonItem>
                      <IonText>
                        <span>
                          <IonIcon
                            size="small"
                            color="dark"
                            src={cubeOutline}
                          ></IonIcon>
                          {" " + value.contract_grouping}
                        </span>{" "}
                        <br />
                        <span>
                          <IonIcon
                            size="small"
                            color="dark"
                            src={medalOutline}
                          ></IonIcon>
                          {" " + value.contract_reward_name}
                        </span>{" "}
                        <br />
                        <span>
                          <IonIcon
                            size="small"
                            color="dark"
                            src={fileTrayStackedOutline}
                          ></IonIcon>
                          {" Target "}
                          {value.contract_target_amount
                            ? ` ${Number(value.contract_target_amount)} Point`
                            : value.contract_target_amount
                            ? ` ${Number(value.contract_target_amount)} ${t(
                                "price"
                              )}`
                            : ` ${Number(value.contract_target_quantity)} ${t(
                                "quantity"
                              )}`}
                        </span>
                        <br/>
                        <span>
                          <IonIcon
                            size="small"
                            color="dark"
                            src={cashOutline}
                          ></IonIcon>
                          {" Reward " + Rupiah(value.contract_reward_amount)}
                        </span>{" "}
                      </IonText>
                    </IonItem>
                    <IonItem>
                      <IonText>
                        <IonLabel className="ion-no-padding ion-no-margin">
                          <p>Achievement</p>
                        </IonLabel>
                        <span>
                          <IonIcon
                            size="small"
                            color="dark"
                            src={fileTrayStackedOutline}
                          ></IonIcon>{" "}
                          {Number(value.contract_target_quantity) * 1
                            ? Number(value.sales?.sales_quantity ?? 0)
                            : Number(value.contract_target_amount) * 1
                            ? Number(value.sales?.sales_amount ?? 0)
                            : Number(value.contract_target_point) * 1
                            ? Number(value.sales?.sales_point ?? 0)
                            : 0}{" "}
                          {t("quantity")}
                        </span>
                        <br />
                        <span>
                          <IonIcon
                            size="small"
                            color="dark"
                            src={cashOutline}
                          ></IonIcon>
                          {" " +
                            Rupiah(
                              Number(value.contract_disc_amount) *
                                Number(value.sales?.sales_quantity ?? 0)
                            )}{" "}
                          {t("Budget")}
                        </span>
                        <br />
                        <span>
                          <IonIcon
                            size="small"
                            color="dark"
                            src={discOutline}
                          ></IonIcon>{" "}
                          {Math.round(
                            Number(value.contract_target_quantity) * 1
                              ? (Number(value.sales?.sales_quantity ?? 0) /
                                  Number(value.contract_target_quantity)) *
                                  100
                              : Number(value.contract_target_amount) * 1
                              ? (Number(value.sales?.sales_amount ?? 0) /
                                  Number(value.contract_target_amount)) *
                                100
                              : Number(value.contract_target_point) * 1
                              ? (Number(value.sales?.sales_point ?? 0) /
                                  Number(value.contract_target_point)) *
                                100
                              : 0
                          )}
                          {"%"}
                        </span>
                      </IonText>
                    </IonItem>
                  </IonCard>
                </IonCol>
              ))}
            </IonRow>
            <IonInfiniteScroll
              onIonInfinite={loadData}
              threshold="100px"
              disabled={isInfiniteDisabled}
            >
              {dataContract.next_page_url && (
                <IonInfiniteScrollContent
                  loadingSpinner="bubbles"
                  loadingText={`${t("loading")}`}
                >
                  <IonRow>
                    <IonCol size="12">
                      <IonCard className="ion-no-padding">
                        <IonSkeletonText
                          animated={true}
                          style={{ width: "100%", height: "110px" }}
                        ></IonSkeletonText>
                        <IonCardHeader
                          className="ion-no-padding"
                          style={{
                            margin: "3px",
                          }}
                        >
                          <IonCardSubtitle className="ion-no-padding">
                            <IonBadge color="danger" style={{ width: "100%" }}>
                              <IonSkeletonText
                                animated={true}
                                style={{ width: "100%" }}
                              ></IonSkeletonText>
                            </IonBadge>
                          </IonCardSubtitle>
                          <IonCardTitle className="ion-no-padding">
                            <IonTitle size="small" className="ion-no-padding">
                              <IonSkeletonText
                                animated={true}
                                style={{ width: "100%" }}
                              ></IonSkeletonText>
                            </IonTitle>
                          </IonCardTitle>
                        </IonCardHeader>
                      </IonCard>
                    </IonCol>
                  </IonRow>
                </IonInfiniteScrollContent>
              )}
            </IonInfiniteScroll>
          </IonGrid>
        ) : dataContract != null ? (
          <IonImg className="img-empty" src={"assets/img/search-empty.png"} />
        ) : (
          <IonInfiniteScrollContent
            loadingSpinner="bubbles"
            loadingText={`${t("loading")}`}
          >
            <IonRow>
              {loadList.map((value: any, key: any) => (
                <IonCol size="12" key={key}>
                  <IonCard className="ion-no-padding">
                    <IonSkeletonText
                      animated={true}
                      style={{ width: "100%", height: "110px" }}
                    ></IonSkeletonText>
                    <IonCardHeader
                      className="ion-no-padding"
                      style={{
                        margin: "3px",
                      }}
                    >
                      <IonCardSubtitle className="ion-no-padding">
                        <IonBadge color="danger" style={{ width: "100%" }}>
                          <IonSkeletonText
                            animated={true}
                            style={{ width: "100%" }}
                          ></IonSkeletonText>
                        </IonBadge>
                      </IonCardSubtitle>
                      <IonCardTitle className="ion-no-padding">
                        <IonTitle size="small" className="ion-no-padding">
                          <IonSkeletonText
                            animated={true}
                            style={{ width: "100%" }}
                          ></IonSkeletonText>
                        </IonTitle>
                      </IonCardTitle>
                    </IonCardHeader>
                  </IonCard>
                </IonCol>
              ))}
            </IonRow>
          </IonInfiniteScrollContent>
        )}
      </IonContent>

      <Filter onCloseModal={handleModalCloseFilter} isOpen={showModalFilter} />
    </IonPage>
  );
};

const Filter: React.FC<any> = ({ onCloseModal, isOpen }) => {
  const modalFilterInvoice = useRef<HTMLIonModalElement>(null);
  const { t } = useTranslation(["general"]);
  const [state, setState] = useState<any>({
    status: [],
  });
  const onWillDismiss = (ev: CustomEvent<OverlayEventDetail>) => {
    onCloseModal(false);
    modalFilterInvoice.current?.dismiss();
  };

  const choseMultiFilter = (filterId: any, arr: any = []) => {
    const check = state[arr].includes(filterId);
    if (check) {
      setState((prevState: any) => ({
        ...prevState,
        [arr]: state[arr].filter((id: any) => id !== filterId),
      }));
    } else {
      setState((prevState: any) => ({
        ...prevState,
        [arr]: [...state[arr], filterId],
      }));
    }
  };

  const clearFilters = () => {
    setState([]);
  };

  const filterItem = () => {
    modalFilterInvoice.current?.dismiss();
    onCloseModal(state);
  };

  return (
    <IonModal
      ref={modalFilterInvoice}
      isOpen={isOpen}
      className="ion-modal"
      initialBreakpoint={0.8}
      breakpoints={[0, 1.0]}
      handleBehavior="cycle"
      onWillDismiss={(ev) => onWillDismiss(ev)}
    >
      <IonHeader>
        <IonToolbar>
          <IonText color="light" slot="start" className="ion-padding-start">
            <h4> {t("filter")}</h4>
          </IonText>
          {state.status ? (
            <IonButton slot="end" fill="clear" onClick={clearFilters}>
              <IonText color="danger">Reset</IonText>
            </IonButton>
          ) : (
            ""
          )}
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding-start">
        {state.status ? (
          <IonFab slot="fixed" vertical="top" horizontal="end">
            <IonFabButton color="danger" onClick={filterItem}>
              <IonIcon size="large" icon={searchCircle}></IonIcon>
            </IonFabButton>
          </IonFab>
        ) : (
          ""
        )}

        <IonList className="ion-no-padding">
          <IonItemGroup>
            <IonItemDivider className="ion-no-padding">
              <IonText className="ion-no-padding" color="dark">
                Status {t("order")}
              </IonText>
            </IonItemDivider>{" "}
            <IonItem className="ion-no-padding" lines="none">
              <IonRow className="ion-margin-bottom">
                <IonCol size="12">
                  {[0, 1, 2, 3, 4, 5, 6, 7].map((item: any, key: number) => {
                    const isSelected = state.status.includes(item);
                    return (
                      <IonButton
                        key={key}
                        color={isSelected ? "danger" : "medium"}
                        fill="outline"
                        size="small"
                        style={{ marginBottom: "15px" }}
                        onClick={() => choseMultiFilter(item, "status")}
                      >
                        <IonText>{t(`status.${item}`)}</IonText>
                      </IonButton>
                    );
                  })}
                </IonCol>
              </IonRow>
            </IonItem>
          </IonItemGroup>
        </IonList>
      </IonContent>
    </IonModal>
  );
};  

export default Contract;
